import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Drawer, unstable_useEnhancedEffect } from "@mui/material";
import { styled } from '@mui/system'
import { Theme } from "@mui/material";
import { Scrollbars } from 'react-custom-scrollbars';
import { Link } from "react-router-dom";
import useIsBelow651 from "../../../utils/screenCheck";



const useStyles = makeStyles((theme: Theme)=>{
    return {
        imgHolder: {
            padding: '40px 20px 20px',
        },
        ul: {
            padding: '20px 0',
            listStyle: 'none'
        },
        li: {
            marginBottom: '32px',
            listStyleType: 'none',
        },
        link: {
            color: '#d1a23c',
            opacity: 1,
            borderRadius: '15px 0 0 15px',
            backgroundColor: '#d1a23c',
            fontSize: '14px',
            letterSpacing: '.35px',
            padding: '8px 20px',
            fontWeight: 900,
            borderLeft: '4px solid transparent',
            display: 'flex',
            alignItems: 'center',
            transition: 'opacity 1.2s',
            marginBottom: 0,
            marginLeft: '16px',
            textDecoration: 'none',
        },
        linkWidthAfter: {
            color: '#d1a23c',
            opacity: 1,
            borderRadius: '15px 0 0 15px',
            // backgroundColor: '#d1a23c',
            fontSize: '14px',
            letterSpacing: '.35px',
            padding: '8px 20px',
            fontWeight: 900,
            borderLeft: '4px solid transparent',
            display: 'flex',
            alignItems: 'center',
            transition: 'opacity 1.2s',
            marginBottom: 0,
            marginLeft: '16px',
            textDecoration: 'none',

            "&:after": {
                right: '0 !important',
                content: "''",
                width: '12px',
                height: '7.42px',
                maskImage: 'url(/imgs/nav-icons/sue.svg)',
                display: 'block',
                marginLeft: 'auto',
                transform: 'rotate(180deg)',
                transition: 'all .5s ease',
                background: '#111',
                opacity: 1,
                color: '#111',
                position: 'relative',
            }
        },
        linkWidthAfterActive: {
            color: '#d1a23c',
            opacity: 1,
            borderRadius: '15px 0 0 15px',
            // backgroundColor: '#d1a23c',
            fontSize: '14px',
            letterSpacing: '.35px',
            padding: '8px 20px',
            fontWeight: 900,
            borderLeft: '4px solid transparent',
            display: 'flex',
            alignItems: 'center',
            transition: 'opacity 1.2s',
            marginBottom: 0,
            marginLeft: '16px',
            textDecoration: 'none',

            "&:after": {
                right: '0 !important',
                content: "''",
                width: '12px',
                height: '7.42px',
                maskImage: 'url(/imgs/nav-icons/sue.svg)',
                display: 'block',
                marginLeft: 'auto',
                transform: 'rotate(0deg)',
                transition: 'all .5s ease',
                background: '#111',
                opacity: 1,
                color: '#111',
                position: 'relative',
            }
        },
        linkWidthNoAfter: {
            color: '#d1a23c',
            opacity: 1,
            borderRadius: '15px 0 0 15px',
            // backgroundColor: '#d1a23c',
            fontSize: '14px',
            letterSpacing: '.35px',
            padding: '8px 20px',
            fontWeight: 900,
            borderLeft: '4px solid transparent',
            display: 'flex',
            alignItems: 'center',
            transition: 'opacity 1.2s',
            marginBottom: 0,
            marginLeft: '16px',
            textDecoration: 'none',
        },

        linkSpanText: {
            color: '#fff !important',
            paddingTop: '0 !important',
            margin: 'auto auto auto 13px',
            display: 'inline-block',
        },
        linkSpanTextUnActive: {
            color: '#000 !important',
            paddingTop: '0 !important',
            margin: 'auto auto auto 13px',
            display: 'inline-block',
        },
        linkSpanImg: {
            backgroundColor: '#fff',
            opacity: 1,
            mask: 'url(/imgs/nav-icons/home.svg) no-repeat center left',
            width: '18px',
            height: '18px',
            display: 'inline-block',
            transition: 'all .5s',
        },
        linkSpanImgUnActive: {
            backgroundColor: '#000',
            opacity: 1,
            width: '18px',
            height: '18px',
            display: 'inline-block',
            transition: 'all .5s',
        },

        dropdownMenu: {
            display: 'none'
        },
        dropdownMenuShow: {
            position: 'relative',
            padding: 'unset !important',
            float: 'unset',
            transform: 'unset !important',
            top: 'unset !important',
            left: 'unset !important',
            willChange: 'unset !important',
            backgroundColor: 'unset !important',
            border: 'none !important',

            zIndex: '1000',
            display: 'block',
            minWidth: '10rem',
            margin: '0.125rem 0 0',
            fontSize: '1rem',
            color: '#212529',
            textAlign: 'left',
            listStyle: 'none',
            backgroundClip: 'padding-box',
            borderRadius: '0.25rem',
        },

        dropdownMenuActive: {
            position: 'relative',
            padding: 'unset !important',
            float: 'unset',
            transform: 'unset !important',
            top: 'unset !important',
            left: 'unset !important',
            willChange: 'unset !important',
            backgroundColor: 'unset !important',
            border: 'none !important',

            zIndex: '1000',
            display: 'none',
            minWidth: '10rem',
            margin: '0.125rem 0 0',
            fontSize: '1rem',
            color: '#212529',
            textAlign: 'left',
            listStyle: 'none',
            backgroundClip: 'padding-box',
            borderRadius: '0.25rem',
        },

        dropdownItem: {
            color: '#000 !important',
            padding: '15px 20px 10px 55px !important',
            borderLeft: '4px solid transparent',

            fontSize: '14px',
            letterSpacing: '.35px',
            fontWeight: 900,
            opacity: 1,
            display: 'flex',
            alignItems: 'center',
            transition: 'opacity 1.2s',
            marginBottom: 0,
            marginLeft: '16px',

            width: '100%',
            clear: 'both',
            textAlign: 'inherit',
            whiteSpace: 'nowrap',
            backgroundColor: 'initial',
            border: 0,
            textDecoration: 'none',
        },
        dropdownItemActive: {
            color: '#d1a23c !important',
            padding: '15px 20px 10px 55px !important',
            borderLeft: '4px solid transparent',

            fontSize: '14px',
            letterSpacing: '.35px',
            fontWeight: 900,
            opacity: 1,
            display: 'flex',
            alignItems: 'center',
            transition: 'opacity 1.2s',
            marginBottom: 0,
            marginLeft: '16px',

            width: '100%',
            clear: 'both',
            textAlign: 'inherit',
            whiteSpace: 'nowrap',
            backgroundColor: 'initial',
            border: 0,
            textDecoration: 'none',
        }
    }
})




interface Props {
    namefromApp: string
    handleTopupOpen: ()=> void
    handleNavClose: ()=> void
}

const NavBar: React.FC<Props>=({namefromApp, handleTopupOpen, handleNavClose})=>{
    const classes = useStyles()
    const [activeNav, setActiveNav] = useState<string>(namefromApp)
    const isMobile = useIsBelow651();


    const Navigation = styled('nav')(({ theme }) => ({
        // width: '250px',
        // position: 'fixed',
        // top: 0,
        // left: 0,
        // height: '100vh',
        // zIndex: '999',
        // background: '#fff',
        // color: '#fff',
        // transition: 'all 0.3s',
        // touchAction: 'pinch-zoom',
        // overflow: 'visible',
        // display: 'block',
        // marginLeft: 0,

        
        // [theme.breakpoints.down('md')]: {
        // },
        // [theme.breakpoints.down('md')]: {
        // },
    }));
    const NavigationInner = styled('div')(({ theme }) => ({
        maxHeight: 'none',
        position: 'relative',
        overflow: 'hidden',
        height: '100%',
        maxWidth: '100%',
        outline: 'none',
        direction: 'ltr'
    }));
    const NavigationInner2 = styled('div')(({ theme }) => ({
        position: 'relative',
        top: 0,
        left: 0,
        overflow: 'hidden',
        overflowY: 'auto',
        width: 'auto',
        height: 'auto',
    }));


    const handleNavigation =(name: string)=> {
        if(name === 'bills-link'){
            if(activeNav === 'pay-bills' || activeNav === 'manage-bills'){
                document.getElementById('bills-link-dropdown')!.classList.toggle('show_second')
            }else{

                document.getElementById('bills-link')!.classList.toggle('linkWidthAfter')
                document.getElementById('bills-link')!.classList.toggle('linkWidthAfter2')
    
                document.getElementById('bills-link-dropdown')!.classList.toggle('show_second')
            }


        }else if(name === 'savings-link'){
            if(activeNav === 'savings-goal' || activeNav === 'emergency-savings' || activeNav === 'spend-and-save'){
                document.getElementById('savings-link-dropdown')!.classList.toggle('show_second')
            }else{

                document.getElementById('savings-link')!.classList.toggle('linkWidthAfter')
                document.getElementById('savings-link')!.classList.toggle('linkWidthAfter2')
    
                document.getElementById('savings-link-dropdown')!.classList.toggle('show_second')
            }
        }else if(name === 'finance-link'){
            if(activeNav === 'transaction-history' || activeNav === 'account-statement'){
                document.getElementById('finance-link-dropdown')!.classList.toggle('show_second')
            }else{

                document.getElementById('finance-link')!.classList.toggle('linkWidthAfter')
                document.getElementById('finance-link')!.classList.toggle('linkWidthAfter2')
    
                document.getElementById('finance-link-dropdown')!.classList.toggle('show_second')
            }
        }
        else{
            setActiveNav(name)
            if(isMobile){
                handleNavClose()
            }
        }


    }


    
    useEffect(()=>{
        switch (window.location.pathname) {
            case '/dashboard':
                setActiveNav('home')
                break;
            case '/dashboard/transfer-funds':
                setActiveNav('send-money')
                break;
            case '/dashboard/investments':
                setActiveNav('invest')
                break;
            case '/dashboard/investments/new':
                setActiveNav('invest')
                break;
            case '/dashboard/beneficiaries':
                setActiveNav('beneficiaries')
                break;
            case '/dashboard/transaction-history':
                setActiveNav('transaction-history')
                break;
            case '/dashboard/account-statement':
                setActiveNav('account-statement')
                break;
            case '/dashboard/manage-bills':
                setActiveNav('manage-bills')
                break;
            case '/dashboard/pay-bills':
                setActiveNav('pay-bills')
                break;
            case '/dashboard/account-settings':
                setActiveNav('settings')
                break;

                
        
            default:
                break;
        }
    })

    const websiteHomePage = process.env.REACT_APP_WEBSITE_HOME_PAGE || ''

    const handleLogout = () => {
      localStorage.removeItem("loginID");
      window.location.replace(websiteHomePage)
    };


    return (
        <nav id="sidebar" style={{overflow: 'visible'}}>
            <NavigationInner >
                <Scrollbars 
                    style={{transform: 'translateZ(-100px)'}}
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}>
                    <NavigationInner2>
                        <div className={classes.imgHolder}>
                            <img src="/imgs/altlogo.png" alt=""/>
                        </div>


                        <ul className={classes.ul}>

                            <li className={classes.li} onClick={()=> handleNavigation('home')}>
                                <Link to="/dashboard" className={activeNav === 'home' ? classes.link : classes.linkWidthNoAfter}>
                                    <span style={{mask: 'url(/imgs/nav-icons/home.svg) no-repeat center left'}} className={activeNav === 'home' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'home' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Home</span>
                                </Link>
                            </li>
                            


                            <li className={classes.li} onClick={()=> handleNavigation('bills-link')}>
                                <span id="bills-link" className={ activeNav === 'pay-bills' || activeNav === 'manage-bills' ? classes.link : 'linkWidthAfter'}>
                                    <span style={{mask: 'url(/imgs/nav-icons/bills.svg) no-repeat center left'}} className={activeNav === 'pay-bills' || activeNav === 'manage-bills' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'pay-bills' || activeNav === 'manage-bills' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Bills</span>
                                </span>
                                <div id="bills-link-dropdown" className='dropdownMenu'>
                                    <form>
                                        <Link onClick={()=> handleNavigation('pay-bills')} className={activeNav === 'pay-bills' ? classes.dropdownItemActive : classes.dropdownItem} to="/dashboard/pay-bills">Pay Bills</Link>
                                        <Link onClick={()=> handleNavigation('manage-bills')} className={activeNav === 'manage-bills' ? classes.dropdownItemActive : classes.dropdownItem} to="/dashboard/manage-bills">Manage Bills</Link>
                                    </form>
                                </div>
                            </li>
                            

                            <li className={classes.li} onClick={handleTopupOpen}>
                                <span className={activeNav === 'top-up' ? classes.link :  classes.linkWidthNoAfter}>
                                    <span style={{mask: 'url(/imgs/nav-icons/top-up.svg) no-repeat center left'}} className={activeNav === 'top-up' ? classes.linkSpanImg : classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'top-up' ? classes.linkSpanText : classes.linkSpanTextUnActive}>Receive Funds</span>
                                </span>
                            </li>


                            
                            {/* <li className={classes.li} onClick={()=> handleNavigation('savings-link')}>
                                <span id="savings-link" className={ activeNav === 'savings-goal' || activeNav === 'emergency-savings' || activeNav === 'spend-and-save' ? classes.link : 'linkWidthAfter'}>
                                    <span style={{mask: 'url(/imgs/nav-icons/bills.svg) no-repeat center left'}} className={activeNav === 'savings-goal' || activeNav === 'emergency-savings' || activeNav === 'spend-and-save' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'savings-goal' || activeNav === 'emergency-savings' || activeNav === 'spend-and-save' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Savings</span>
                                </span>
                                <div id="savings-link-dropdown" className='dropdownMenu'>
                                    <form>
                                        <span onClick={()=> handleNavigation('savings-goal')} className={activeNav === 'savings-goal' ? classes.dropdownItemActive : classes.dropdownItem} to="">Savings Goals</span>
                                        <span onClick={()=> handleNavigation('emergency-savings')} className={activeNav === 'emergency-savings' ? classes.dropdownItemActive : classes.dropdownItem} to="">Emergency Savings</span>
                                        <span onClick={()=> handleNavigation('spend-and-save')} className={activeNav === 'spend-and-save' ? classes.dropdownItemActive : classes.dropdownItem} to="">Spend and Save</span>
                                    </form>
                                </div>
                            </li> */}



                            <li className={classes.li} onClick={()=> handleNavigation('send-money')}>
                                <Link to="/dashboard/transfer-funds" className={activeNav === 'send-money' ? classes.link : classes.linkWidthNoAfter}>
                                    <span style={{mask: 'url(/imgs/nav-icons/send.svg) no-repeat center left'}} className={activeNav === 'send-money' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'send-money' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Send Money</span>
                                </Link>
                            </li>


                            {/* <li className={classes.li} onClick={()=> handleNavigation('split')}>
                                <Link to="#" className={activeNav === 'split' ? classes.link : classes.linkWidthNoAfter}>
                                    <span style={{mask: 'url(/imgs/nav-icons/send.svg) no-repeat center left'}} className={activeNav === 'split' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'split' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Split Payment</span>
                                </Link>
                            </li> */}



                            <li className={classes.li} onClick={()=> handleNavigation('invest')}>
                                <Link to="/dashboard/investments" className={activeNav === 'invest' || activeNav === 'invest-new' ? classes.link : classes.linkWidthNoAfter}>
                                    <span style={{mask: 'url(/imgs/nav-icons/invest.svg) no-repeat center left'}} className={activeNav === 'invest' || activeNav === 'invest-new' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'invest' || activeNav === 'invest-new' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Investments</span>
                                </Link>
                            </li>


                            <li className={classes.li} onClick={()=> handleNavigation('beneficiaries')}>
                                <Link to="/dashboard/beneficiaries" className={activeNav === 'beneficiaries' ? classes.link : classes.linkWidthNoAfter}>
                                    <span style={{mask: 'url(/imgs/nav-icons/beneficiaries.svg) no-repeat center left'}} className={activeNav === 'beneficiaries' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'beneficiaries' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Beneficiaries</span>
                                </Link>
                            </li>


                            <li className={classes.li} onClick={()=> handleNavigation('finance-link')}>
                                <span id="finance-link" className={ activeNav === 'transaction-history' || activeNav === 'account-statement' ? classes.link : 'linkWidthAfter'}>
                                    <span style={{mask: 'url(/imgs/nav-icons/bills.svg) no-repeat center left'}} className={activeNav === 'transaction-history' || activeNav === 'account-statement' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'transaction-history' || activeNav === 'account-statement' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Finance</span>
                                </span>
                                <div id="finance-link-dropdown" className='dropdownMenu'>
                                    <form>
                                        <Link onClick={()=> handleNavigation('transaction-history')} className={activeNav === 'transaction-history' ? classes.dropdownItemActive : classes.dropdownItem} to="/dashboard/transaction-history">Transaction History</Link>
                                        <Link onClick={()=> handleNavigation('account-statement')} className={activeNav === 'account-statement' ? classes.dropdownItemActive : classes.dropdownItem} to="/dashboard/account-statement">Account Statement</Link>
                                    </form>
                                </div>
                            </li>
                            

                            <li className={classes.li} onClick={()=> handleNavigation('settings')}>
                                <Link to="/dashboard/account-settings" className={activeNav === 'settings' ? classes.link : classes.linkWidthNoAfter}>
                                    <span style={{mask: 'url(/imgs/nav-icons/settings.svg) no-repeat center left'}} className={activeNav === 'settings' ? classes.linkSpanImg :  classes.linkSpanImgUnActive}></span>
                                    <span className={activeNav === 'settings' ? classes.linkSpanText :  classes.linkSpanTextUnActive}>Settings</span>
                                </Link>
                            </li>

                            <hr />
                            
                            <li className={classes.li} style={{marginBottom: '0', cursor: 'pointer'}} onClick={()=> handleLogout()}>
                                <div className={classes.linkWidthNoAfter}>
                                    <span style={{mask: 'url(/imgs/nav-icons/logout.svg) no-repeat center left'}} className={classes.linkSpanImgUnActive}></span>
                                    <span className={classes.linkSpanTextUnActive}>Log out</span>
                                </div>
                            </li>

                        </ul>

                    </NavigationInner2> 
                </Scrollbars>
            </NavigationInner>
        </nav>
    )
}

export default NavBar